<template>
  <div class="grid-container">
    <form :class="{'opacity-50': isWorking}" @submit.prevent="submit">
      <section-header class="my-3" variants="dividing" size="xl">
        <heading level="1" size="xl" v-html="bp('updatePwd.title')"></heading>
      </section-header>
      <pdl-callout v-if="message" :kind="messageType">
        <template #content>
          <span v-html="message" />
        </template>
      </pdl-callout>
      <div class="max-w-sm mb-6">
        <form-group
          v-model="currentPassword"
          v-validate="'required'"
          type="password"
          name="currentPassword"
          :label="bp('profile.currentPassword')"
          :data-vv-as="bp('profile.currentPassword')"
          :error="getErrorMessage('currentPassword')"
          force-display-error
          show-error-messages
          required
          @change="resetErrorMessage('currentPassword')"
        />

        <form-group
          ref="newPassword"
          v-model="newPassword"
          v-validate="'required|checkPassword'"
          type="password"
          name="newPassword"
          :label="bp('profile.newPassword')"
          :data-vv-as="bp('profile.newPassword')"
          :error="getErrorMessage('newPassword')"
          :help-text="bp('register.infoPassword')"
          force-display-error
          show-error-messages
          required
          @change="resetErrorMessage('newPassword')"
        />

        <form-group
          v-model="checkNewPassword"
          v-validate="'required|confirmed:newPassword|checkPassword'"
          type="password"
          name="checkNewPassword"
          :label="bp('profile.checkNewPassword')"
          :data-vv-as="bp('profile.checkNewPassword')"
          :error="getErrorMessage('checkNewPassword')"
          force-display-error
          show-error-messages
          required
          @change="resetErrorMessage('checkNewPassword')"
        />
        <div class="buttons">
          <trek-button primary type="submit" qaid="update-password-button" :disabled="isWorking" @click="submit"
            ><span v-html="bp('profile.submit')"></span
          ></trek-button>
          <trek-button secondary qaid="cancel-update-password-button" @click="cancel"
            ><span v-html="bp('text.account.profile.cancel')"></span
          ></trek-button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import get from 'lodash/get';
import Heading from '@/components/Heading';
import {PdlCallout} from '@pedal/pdl-callout';
import FormGroup from '@/components/FormGroup';
import TrekButton from '@/components/TrekButton';
import SectionHeader from '@/components/SectionHeader';
import {initPasswordRules} from '@/components/containers/my-account/utils/password-rules';
import {UserAccountBase} from '@/components/containers/my-account/utils/user-account-base';
import {WithErrorFields} from '@/components/containers/my-account/utils/with-error-fields';

export default {
  name: 'UpdatePasswordContainer',
  components: {Heading, PdlCallout, FormGroup, TrekButton, SectionHeader},
  extends: UserAccountBase,
  mixins: [WithErrorFields],
  data() {
    return {
      currentPassword: '',
      newPassword: '',
      checkNewPassword: '',
    };
  },
  created() {
    this.useCustomPasswordValidationMessages({
      passwordField: ['currentPassword', 'newPassword'],
      passwordConfirmationField: 'checkNewPassword',
    });
    initPasswordRules(this.bp('register.infoPassword'));
  },
  methods: {
    /**
     * Handle email update.
     * @return {Promise<void>}
     */
    async processUpdate() {
      this.isWorking = true;
      this.errorFields = {};

      try {
        const response = await this.api.updatePassword({
          currentPassword: this.currentPassword,
          newPassword: this.newPassword,
          checkNewPassword: this.checkNewPassword,
          CSRFToken: this.options.CSRFToken,
        });

        const isError = get(response.data.meta, 'feedback.type') !== 'success';
        const message = get(response.data.meta, 'feedback.message.basePropertyValue');

        if (isError) {
          this.displayError(message);
          this.errorFields = get(response.data, 'meta.feedback.errorFields', {});
        } else {
          this.displaySuccess(message);
          this.resetForm();
        }
      } catch (e) {
        this.displayError(e.message);
      } finally {
        this.isWorking = false;
      }
    },

    /**
     * Reset form data.
     */
    resetForm() {
      this.errorFields = {};
      this.currentPassword = '';
      this.newPassword = '';
      this.checkNewPassword = '';
    },
  },
};
</script>
